import { Star, StarHalf } from 'lucide-react'
import { type RouterOutputs } from '@/trpc/react'
import { QuoteIcon } from '../icons/quote-icon'
import { ImageLoader } from '../ui/image-loader'
import { AVATAR_PLACEHOLDER } from '@/lib/constant'
import { cloudFrontUrl } from '@/lib/utils'

type TestimonialType = RouterOutputs['testimonial']['get_testimonials'][0]

const TestimonialCard = ({ data }: { data: TestimonialType }) => {
    return (
        <div className='bg-white rounded-lg shadow-sm p-4 pb-0 relative flex flex-col gap-4 select-none border border-gray-200'>
            <div className='h-12 md:h-16 w-12 md:w-16 p-2.5 rounded-b-md absolute top-0 right-2.5'>
                <QuoteIcon className='h-full w-full' />
            </div>
            <div className='flex flex-row gap-6'>
                <div className='relative h-16 w-16 md:h-20 md:w-20 rounded-md overflow-hidden shrink-0'>
                    <ImageLoader src={data.image_url ? cloudFrontUrl(data.image_url) : AVATAR_PLACEHOLDER} alt={data.name} fill className='object-cover' />
                </div>
                <div className='flex flex-col justify-center'>
                    <h3 className='text-xl text-black font-lexend font-semibold capitalize'>
                        {data.name}
                    </h3>
                    <p className='text-secondary-text font-lexend capitalize'>
                        {data.designation}
                    </p>
                </div>
            </div>
            <div className="flex flex-row gap-4  items-center">
                <p className="text-secondary-text font-medium">{data.rating} Rating</p>
                <div className="flex flex-row flex-nowrap shrink-0 gap-1">
                    {Array.from({ length: 5 }).map((_, index) => {
                        if (data.rating >= index + 1) {
                            // Full Star
                            return (
                                <Star
                                    key={index}
                                    className="h-4 w-4 text-custom-secondary fill-custom-secondary"
                                />
                            );
                        } else if (data.rating > index && data.rating < index + 1) {
                            // Half Star
                            return (
                                <StarHalf
                                    key={index}
                                    className="h-4 w-4 text-custom-secondary fill-custom-secondary"
                                />
                            );
                        } else {
                            // Empty Star
                            return (
                                <Star
                                    key={index}
                                    className="h-4 w-4 text-custom-secondary"
                                />
                            );
                        }
                    })}
                </div>
            </div>
            <div className='h-44 pb-4 overflow-y-scroll custom-scrollbar'>
                <p className='text-primary-text font-normal'>
                    {data.content}
                </p>
            </div>
        </div>
    )
}

export default TestimonialCard